<template>
  <wizard-summary-option
    v-if="wizard.askRegion && wizard.sceltaLocationDeploy"
    :name="$t('32 GB RAM addizionali')"
    :value="wizard.siNo(wizard.addOn32Ram)"
    edit-step="WizardStepProdottiInfrastruttura"
    ouia-id="wizard-summary-host-addon-ram"
  />
  <wizard-summary-option
    v-if="wizard.askRegion && wizard.askRegionBackup && wizard.sceltaLocationBackup"
    :name="$t('8 IP aggiuntivi')"
    :value="wizard.siNo(wizard.addOn8Ip)"
    edit-step="WizardStepProdottiInfrastruttura"
    ouia-id="wizard-summary-host-addon-ips"
  />
</template>

<script lang="ts" setup>
import WizardSummaryOption from './wizard-summary-option.vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();
</script>
